import { Controller } from 'stimulus';

export default class extends Controller {
  reloadPage(event) {
    event.preventDefault();
    document.location.reload();
  }
}
